import React from 'react'
import { ReviewTile } from './ReviewTile'
import { Review } from 'components/supplier_show/prop_shapes/review'

interface ReviewTilesProps {
  reviews: Review[]
  displaySupplierName?: boolean
  noPadding?: boolean
}

export const ReviewTiles: React.FC<ReviewTilesProps> = ({
  reviews,
  displaySupplierName,
  noPadding = false
}) => {
  const sortedReviews = reviews.sort((a, b) => -a.review_date.localeCompare(b.review_date))
  return (
    <>
      {sortedReviews.map(review => (
        <ReviewTile
          review={review}
          key={review.id}
          displaySupplierName={displaySupplierName}
          noPadding={noPadding}
        />
      ))}
    </>
  )
}

export default ReviewTiles
